/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FunnelStats interface.
 */
export function instanceOfFunnelStats(value) {
    if (!('claimedAcquisitions' in value) || value['claimedAcquisitions'] === undefined)
        return false;
    if (!('installStitched' in value) || value['installStitched'] === undefined)
        return false;
    if (!('purchasesWithSnapshot' in value) || value['purchasesWithSnapshot'] === undefined)
        return false;
    if (!('visits' in value) || value['visits'] === undefined)
        return false;
    if (!('visitsWithWelcome' in value) || value['visitsWithWelcome'] === undefined)
        return false;
    return true;
}
export function FunnelStatsFromJSON(json) {
    return FunnelStatsFromJSONTyped(json, false);
}
export function FunnelStatsFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'claimedAcquisitions': json['claimed_acquisitions'],
        'installStitched': json['install_stitched'],
        'purchasesWithSnapshot': json['purchases_with_snapshot'],
        'visits': json['visits'],
        'visitsWithWelcome': json['visits_with_welcome'],
    };
}
export function FunnelStatsToJSON(json) {
    return FunnelStatsToJSONTyped(json, false);
}
export function FunnelStatsToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'claimed_acquisitions': value['claimedAcquisitions'],
        'install_stitched': value['installStitched'],
        'purchases_with_snapshot': value['purchasesWithSnapshot'],
        'visits': value['visits'],
        'visits_with_welcome': value['visitsWithWelcome'],
    };
}
